import React, { Fragment, useState, useEffect } from 'react';

import SideNav from '../../../Components/SideNav';
import "../Archivos.css"

import inscripcionesDataHelper from '../../../Helpers/InscripcionData';

import icon1 from "../../../Images/Icon/66.png"
import { useParams } from 'react-router-dom';


const Archivos = () => {
    const { licenciatura } = useParams("licenciatura");
    const cuatrimestresTexto = [
        "Ene - Abr",
        "May - Ago",
        "Sep - Dic"
    ];

    const [archivos, setArchivos] = useState({
        datos: [
            {
                nombre:"Cargando ...",
                fecha:"Cargando ..."
            }
        ]
    });

    useEffect(() => {
        setArchivos({
            ...archivos,
            nombre: licenciatura.toUpperCase()
        });

        obtenerFechas();
    },[]);

    const obtenerFechas = async () => {
        let res = await inscripcionesDataHelper.obtenerDataFecha(true);
        
        if (res.success) {
            obtenerCarpetas(res.data)
        } else {
            console.log("else");
        }
    }

    const obtenerCarpetas = ({primero, ultimo}) => {
        let carpetas = [];
        let priemraFecha = new Date(primero[0].fecha);
        let ultimaFecha = new Date(ultimo[0].fecha);

        let meses = (ultimaFecha.getFullYear() - priemraFecha.getFullYear()) * 12;
        meses -= priemraFecha.getMonth();
        meses += ultimaFecha.getMonth();

        console.log({meses});

        let cuatrimestre = Math.ceil(meses / 4) + 3;

        let anios = priemraFecha;
        anios.setMonth(anios.getMonth() - 2)

        console.log({cuatrimestre});

        for (let index = 0; index <= cuatrimestre; index++) {
            let indexCuatrimestres = index;
            let exedenteIndex = Math.floor(index / 3);
        
            if (index >= 3) {
                indexCuatrimestres -= (3 * exedenteIndex);
            }

            carpetas.push({
                rangoFecha: indexCuatrimestres,
                nombre: cuatrimestresTexto[indexCuatrimestres],
                fecha: anios.getFullYear()
            })

            if (Math.floor(index % 3) === 2) {
                if (exedenteIndex === 0) exedenteIndex += 1;
                
                anios.setFullYear(anios.getFullYear() + 1);
            }
        }

        setArchivos({
            nombre: licenciatura.toUpperCase(),
            datos: carpetas
        })
    }

    return(
        <Fragment>
            <SideNav />
            <div>
                <p className='titulo_solicitud' style={{textAlign:"center"}}>
                    {archivos.nombre}
                </p>
                <div className='cont_2'>
                    
                    <div style={{display:"flex", flexWrap:"wrap", justifyContent:"space-evenly", width:"100%"}}>
                        {archivos.datos.map(dato => (
                            <a href={`/archivo-inscripcion/${dato.rangoFecha}/${dato.fecha}`} className='box_archivos_2'>
                                <img src={icon1} alt="" />
                                <p>
                                    {dato.nombre} <br />
                                    {dato.fecha}
                                </p>            
                            </a>
                        ))}
                    </div>

                    <div style={{display:"flex", justifyContent:"center"}}>
                        <a type="" className='btn_regresar'>
                            Regresar
                        </a>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Archivos;